<template>
    <div>
        <!-- item-->
        <div class="dropdown-item noti-title">
            <h5 class="m-0">
                Job Logs
            </h5>
        </div>
        <perfect-scrollbar class="scroll-area">
            <!-- item-->
            <div class="dropdown-item notify-item" v-for="(jobLog, index) in jobLogs" :key="index">
                <div class="row">
                    <div class="col-md-8">
                        <p class="notify-details">
                            {{jobLog.jobName}}<br/>
                            <small>Started On: {{jobLog.createdAt | formatDate}} <br/> Queue: <b>{{ (jobLog.jobData) ? jobLog.jobData.ip : ''}}</b></small>
                        </p>
                    </div>
                    <div class="col-md-4">
                        <div class="notify-icon">
                            <span class="badge badge-pill badge-success" v-if="jobLog.status === 'complete' && jobLog.progress === 'success'">Completed</span>
                            <span class="badge badge-pill badge-danger" v-else-if="jobLog.status === 'complete' && jobLog.progress === 'error'">Error</span>
                            <span class="badge badge-pill badge-warning" v-else-if="jobLog.status === 'Pending'">Pending</span>
                            <span class="badge badge-pill badge-warning" v-else-if="jobLog.status === 'paused'">Paused</span>
                            <span class="badge badge-pill badge-default" v-else>Running</span>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </div>
</template>

<script>
    import {PerfectScrollbar} from 'vue2-perfect-scrollbar';

    export default {
        name: "TopJobLogs",
        components: {
            PerfectScrollbar,
        },
        computed: {
            jobLogs() {
                return this.$store.getters['notification/getLastTenJobLogs'];
            }
        }
    }
</script>

<style scoped>
    .small_loader{
        width: 15px;
        height: 15px;
        display: inline-grid;
    }
    .slimScrollDiv {
        height: auto !important;
    }
    .scroll-area {
        position: relative;
        width: 350px;
        max-height: 230px;
        overflow: hidden;
    }

    .notification-list .noti-icon-badge {
        display: inline-block;
        position: absolute;
        top: 10px;
        right: 10px;
    }

    .notification-list .fa-bell {
        font-size: 21px;
        vertical-align: middle;
        color: #007bff;
    }

    .notification-list .badge {
        display: inline-block;
        padding: .25em .4em;
        font-size: 75%;
        font-weight: 500;
        line-height: 1;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: .25rem;
        -webkit-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    }

    .notification-list .noti-title {
        background-color: #fff;
        padding: 15px 20px;
    }

    .navbar .navbar-nav .nav-link {
        padding: 0.5rem 0rem;
    }

    .notification-list .h5, .notification-list h5 {
        font-size: .812rem;
    }

    .notification-list .dropdown-item {
        display: block;
        width: 100%;
        padding: .375rem 1.2rem;
        clear: both;
        font-weight: 400;
        color: #72747b;
        text-align: inherit;
        white-space: nowrap;
        background-color: transparent;
        border: 0;
    }

    .notification-list .dropdown-item.active,
    .notification-list .dropdown-item:active,
    .notification-list .dropdown-item:hover {
        color: #323a46;
        text-decoration: none;
        background-color: #f7f7f7 !important;
    }

    .notify-all {
        font-size: .812rem;
    }



    .noti-scroll {
        max-height: 230px;
    }

    .notification-list .notify-item {
        padding: 12px 20px;
    }

    .notification-list .notify-item .notify-details {
        margin-bottom: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #343a40;
        font-size: .8125rem;
    }

    .notification-list .notify-item .user-msg {
        white-space: normal;
        line-height: 16px;
        display: block;
        /*margin-left: 45px;*/
    }

    .notification-list .small, .notification-list small {
        font-size: .75rem;
        font-weight: 400;
    }
    .notification-list .notify-item .notify-icon {
        /*float: left;*/
        height: 36px;
        width: 65px;
        text-align: right;
        border-radius: 50%;
        color: #fff;
    }
</style>
